if (!customElements.get('tabs-component')) {
  class TabsComponent extends HTMLElement {
    constructor() {
      super();

      this.tabsNav = this.querySelector('[data-tabs-nav]');

      this.tabsNav?.addEventListener('click', (e) => {
        if (!e.target.closest('[data-tab-id]')) return;

        e.preventDefault();

        const tabButton = e.target;

        if (tabButton.classList.contains('is-active')) return;

        this.currentTabButton = tabButton;
        this.onTabChange();
      });
    }

    onTabChange() {
      const matchingTab = this.querySelector(
        `[data-tab="${this.currentTabButton.dataset.tabId}"]`,
      );
      const activeButton = this.querySelector('[data-tab-id].is-active');
      const activeTab = this.querySelector('[data-tab].is-active');

      activeButton.classList.remove('is-active');
      activeTab.classList.remove('is-active');

      this.currentTabButton.classList.add('is-active');
      matchingTab.classList.add('is-active');
    }
  }

  customElements.define('tabs-component', TabsComponent);
}
